module.exports = __webpack_public_path__ + "static/media/medication_p2_1.a24b7537.png";